import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

// Rotas onde é permitido veicular anúncios (páginas com conteúdo editorial)
const ALLOWLIST_PATHS = new Set([
    '/faq',
    '/sobre',
    '/privacidade',
    '/guia',
    '/recursos',
    '/artigo-refinamento-backlog',
]);

// Rotas onde NUNCA exibir anúncios (telas utilitárias, navegação, formulários)
const DENYLIST_PATHS = new Set([
    '/',
    '/create',
    '/join',
    '/rooms',
    '/404',
    '/500',
    '/loading',
    '/em-construcao',
]);

function pathIsDenied(pathname) {
    if (DENYLIST_PATHS.has(pathname)) return true;
    // Bloqueia sala de poker (conteúdo dinâmico/ferramenta, não editorial)
    if (pathname.startsWith('/room/')) return true;
    if (pathname.startsWith('/lobby')) return true;
    return false;
}

// Mínimo recomendado pelo AdSense: páginas com conteúdo editorial substancial (evitar "baixo valor")
const MIN_EDITORIAL_CHARS = 600;

function hasEditorialContent(minChars = MIN_EDITORIAL_CHARS) {
    const container = document.querySelector('[data-editorial-content="true"]');
    if (!container) return false;
    const text = container.textContent || '';
    const normalized = text.replace(/\s+/g, ' ').trim();
    return normalized.length >= minChars;
}

export default function AdSlot({ adSlot, format = 'auto', className }) {
    const insRef = useRef(null);
    const [eligible, setEligible] = useState(false);
    const { pathname } = useLocation();

    useEffect(() => {
        // Regra 1: rota precisa estar liberada explicitamente
        const whitelisted = ALLOWLIST_PATHS.has(pathname);

        // Regra 2: bloquear telas utilitárias (home, criar/entrar sala, sala de jogo, etc.)
        const denied = pathIsDenied(pathname);

        // Regra 3: precisa existir conteúdo editorial suficiente na página (política AdSense)
        const enoughContent = hasEditorialContent(MIN_EDITORIAL_CHARS);

        const canShow = whitelisted && !denied && enoughContent;

        setEligible(canShow);
    }, [pathname]);

    useEffect(() => {
        if (!eligible || !insRef.current) return;

        // Garante que o script foi carregado e inicializa o bloco
        try {
            if (window.adsbygoogle && Array.isArray(window.adsbygoogle)) {
                window.adsbygoogle.push({});
            }
        } catch (_e) {
            // falha silenciosa para não quebrar a página
        }
    }, [eligible]);

    if (!eligible) return null;

    return (
        <ins
            ref={insRef}
            className={`adsbygoogle ${className || ''}`}
            style={{ display: 'block' }}
            data-ad-client="ca-pub-7348901130475950"
            data-ad-slot={adSlot}
            data-ad-format={format}
            data-full-width-responsive="true"
        />
    );
}